import axios from 'axios';
import { API_BASE, getAuthToken } from '../utils/api';

const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const getDoctorId = () => {
  const user = localStorage.getItem('user');
  console.log(user)
  if (!user) return '1';
  try {
    const parsed = JSON.parse(user);
    return parsed.id ? parsed.id.toString() : '1';
  } catch {
    return '1';
  }
};

export const fetchDoctorAppointments = async (doctorId?: string) => {
  const id = doctorId || getDoctorId();
  const response = await axios.get(`${API_BASE}/appointments/`, {
    params: { doctor_id: id },
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const fetchAppointmentDetails = async (appointmentId: string) => {
  const response = await axios.get(`${API_BASE}/appointments/${appointmentId}/`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const fetchAppointmentSummary = async (appointmentId: string) => {
  const response = await axios.get(`${API_BASE}/appointments/${appointmentId}/generate_summary/`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
